<script setup>
defineProps({
    themeTitle: {
        type: String,
        required: true,
    },
    colors: {
        type: Array,
        required: true,
    },
    active: {
        type: Boolean,
        default: () => false,
    },
});

const emit = defineEmits(['change-theme']);
</script>

<template>
    <button
        :title="themeTitle"
        :class="['theme-button', {'theme-button--active': active}]"
        @click="emit('change-theme', themeTitle)"
    >
        <span
            v-for="color in colors"
            :key="themeTitle + color"
            :style="{backgroundColor: color}"
            class="theme-button__box"
        />
    </button>
</template>

<style lang="scss">
@import '@/assets/styles/vars.sass';

.theme-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    width: 100%;
    padding: 16px 8px;
    border: none;
    cursor: pointer;
    transition: box-shadow 0.3s ease;

    &--active {
        box-shadow: 0 0 0 8px $shadow;
    }

    &__box {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 4px;
    }
}
</style>
